export const WidgetDataBucketFragment = gql`
  fragment WidgetDataBucketFragment on WidgetDataBucket {
    start
    end
    groups {
      ...WidgetDataGroupFragment
    }
  }
`

export const WidgetDataGroupFragment = gql`
  fragment WidgetDataGroupFragment on WidgetDataGroup {
    values {
      ...ValueForFunctionFragment
    }
    groupBys {
      ...WidgetDataGroupByFragment
    }
  }
`

export const ValueForFunctionFragment = gql`
  fragment ValueForFunctionFragment on ValueForFunction {
    function
    value {
      ...ViewDataElementFragment
    }
  }
`

export const WidgetDataGroupByFragment = gql`
  fragment WidgetDataGroupByFragment on WidgetDataGroupBy {
    columnTemplateId
    key {
      ...ViewDataElementFragment
    }
  }
`
